<template>
  <div>
    <navigation-bar Back Bell/>
    <date-picker :startAt="startAt" :endAt="endAt" @timeSwitchButtonTrigger="timeRangeButton" :canNext="canNext"/>
    <div class="main container">

      <div class="no-data" v-if="orderList.length===0">
        <img src="@/assets/images/empty.svg">
        <p>OH！目前空空的</p>
      </div>

      <template v-for="(item,index) in orderList">
        <store :key="index" :brandName="item.brandName" :brandImage="item.brandImage" :storeName="item.storeName"
               :invoicePrice="item.invoicePrice" :createdAt="item.createdAt" :orderSn="item.orderSn"
               :isOnlineOrder="item.isOnlineOrder" :isPosReserve="item.isPosReserve" :is-web="isWeb"
        />
      </template>
      <infinite-loading slot="append" spinner="waveDots" @infinite="setupDataScroll" ref="infiniteLoading">
        <div slot="no-more">沒有更多資料</div>
        <span slot="no-results"/>
      </infinite-loading>

    </div>
  </div>
</template>

<script>
import DatePicker from './components/datePicker.vue';
import Store from './components/store.vue';
import {notNull} from "@/util/common";

export default {
  name: "History",
  components: {DatePicker, Store},
  props: {
    isWeb: Boolean,
  },
  data() {
    return {
      startAt: this.$store.state.pageSnapshot[this.$route.name]?this.$store.state.pageSnapshot[this.$route.name].startAt:"",
      endAt: this.$store.state.pageSnapshot[this.$route.name]?this.$store.state.pageSnapshot[this.$route.name].endAt:"",
      orderList: [],
      invoicePrice: 0,
      nowMonth: this.$store.state.pageSnapshot[this.$route.name]?this.$store.state.pageSnapshot[this.$route.name].nowMonth:new Date().getMonth() + 1,
      todayMonth: this.$store.state.pageSnapshot[this.$route.name]?this.$store.state.pageSnapshot[this.$route.name].todayMonth:new Date().getMonth() + 1,
      todayYear: this.$store.state.pageSnapshot[this.$route.name]?this.$store.state.pageSnapshot[this.$route.name].todayYear:new Date().getFullYear(),
      canNext: this.$store.state.pageSnapshot[this.$route.name]?this.$store.state.pageSnapshot[this.$route.name].canNext:false,
      orderSn: 0,
      infiniteId: +new Date(),
      pageSize: 10,
      currentPage : 0 ,
      filterStoreId: null, //篩選出某一家店的資料
    }
  },
  created() {
      //取得要單獨過濾的店家ID，line@ web版頁面用
      if (this.isWeb) {
          this.resetByLineWeb();
      }
      this.setup();
  },
  mounted() {

  },
  methods: {
    setup() {
      if (!notNull(this.$store.state.pageSnapshot[this.$route.name])){
        let nowDate = new Date();
        let todayMonth = nowDate.getMonth() + 1;
        let todayYear = nowDate.getFullYear();
        let lastDay = new Date(todayYear, todayMonth, 0);
        let day = lastDay.getDate();
        this.startAt = (todayMonth - 1 === 0 ? todayYear - 1 : todayYear) + '-' + (todayMonth - 1 === 0 ? '12' : todayMonth - 1) + '-01';
        this.endAt = todayYear.toString() + '-' + todayMonth + '-' + day;
      }
    },
    //月份加減
    timeRangeButton: function (value) {
      //偶數月份轉成奇數月份
      if (this.nowMonth % 2 === 0) { // 4 月 -> 3 月
        this.nowMonth = this.nowMonth - 1
      }

      if (value === "timeAdd") {

        if (this.nowMonth + 2 <= 12) {
          this.nowMonth = this.nowMonth + 2
        } else {
          this.nowMonth = 1
          this.todayYear = this.todayYear + 1
        }
        let day = new Date(this.todayYear, this.nowMonth + 1, 0).getDate();
        this.startAt = this.todayYear + '-' + this.nowMonth + '-01'
        this.endAt = this.todayYear.toString() + '-' + (this.nowMonth + 1) + '-' + day

      } else if (value === "timeDes") {

        if (this.nowMonth - 2 > 0) {
          this.nowMonth = this.nowMonth - 2
        } else {
          this.nowMonth = 11
          this.todayYear = this.todayYear - 1
        }
        let day = new Date(this.todayYear, this.nowMonth + 1, 0).getDate();
        this.startAt = this.todayYear.toString() + '-' + this.nowMonth + '-01'
        this.endAt = this.todayYear.toString() + '-' + (this.nowMonth + 1) + '-' + day

      }

      if (new Date().getFullYear() === this.todayYear && this.nowMonth >= (new Date().getMonth())) {
        this.canNext = false
      } else {
        this.canNext = true
      }
      this.currentPage = 0 ;
      this.$refs.infiniteLoading.$emit('infiniteLoading:reset');
      this.getOrderList();
    },
    getOrderList: function () {
      this.$http.fetchWithAuth`GetOrders${{
        'startAt': this.startAt,
        'endAt': this.endAt,
        'OffSet': this.currentPage,
        'limitOrder' : true ,
        'filterStoreId': this.filterStoreId,
      }}
      ${json => {
        if (json.data !== null && json.data !== '') {
          this.orderList = json.data; this.currentPage++ ;
        }
      }
      }}`;
    },
    setupDataScroll: function ($state) {
      let self = this;
      self.isLoading = true;
        this.$http.fetchWithAuth`GetOrders${{
            'startAt': this.startAt,
            'endAt': this.endAt,
            'OffSet': self.currentPage,
            'limitOrder': true,
            'filterStoreId': this.filterStoreId,
        }}
      ${json => {
        if (json.data.length >= self.pageSize) {
          self.currentPage++
          this.orderList.tmz_load_push(...json.data);
          $state.loaded();
        } else {
          self.currentPage++
          self.orderList.tmz_load_push(...json.data);
          $state.complete();
        }
        self.isLoading = false;
      }}`;

    },
      resetByLineWeb() {
          this.filterStoreId = this.$store.state.lineAtWebPageData.filterStoreId;
      },
  },
  // beforeRouteEnter: function(to, from, next) {
  //   next();
  // },
  beforeRouteLeave: function(to, from, next) {
    if (to.name!='More') {
      this.$store.commit("savePageSnapshot",
        { 
          routeName:from.name, 
          variable:{
            startAt:this.startAt,
            endAt:this.endAt,
            nowMonth:this.nowMonth,
            todayMonth:this.todayMonth,
            canNext:this.canNext,
            todayYear:this.todayYear,
          },
        },
      );
    }else{
      this.$store.commit("savePageSnapshot",{routeName:from.name,variable:undefined});
    }
    next();
  },
}
</script>
